import statuses from '@/helpers/statuses'

const initialState = () => ({
  feeds: [],
  meta: {
    loading: statuses.IDLE
  }
})

export default api => ({
  state: initialState,

  getters: {
    feedsLoading: state => state.meta.loading,
    feeds: state => state.feeds || []
  },

  mutations: {
    fetchFeeds: state => {
      state.meta.loading = statuses.LOADING
    },

    fetchFeedsSuccess: (state, payload) => {
      state.meta.loading = statuses.LOADED
      state.feeds = payload
    },

    fetchFeedsFailure: (state, error) => {
      state.meta.loading = statuses.FAILED
    },

    hideCanSayHi: (state, id) => {
      const feedIndex = state.feeds.findIndex(feed => feed.id === id)
      if (feedIndex !== -1) {
        const feed = state.feeds[feedIndex]
        state.feeds.splice(feedIndex, 1, { ...feed, canSayHi: false })
      }
    },

    resetFeeds: state => {
      const payload = initialState()
      Object.keys(payload).forEach(key => {
        state[key] = payload[key]
      })
    }
  },

  actions: {
    fetchFeeds: async ({ commit }) => {
      commit('fetchFeeds')
      try {
        const data = await api.fetchFeeds()
        commit('fetchFeedsSuccess', data)
      } catch (error) {
        commit('fetchFeedsFailure', error)
      }
    },

    hideCanSayHi: ({ commit }, id) => {
      commit('hideCanSayHi', id)
    },

    clear: ({ commit }) => {
      commit('resetFeeds')
    }
  }
})
